import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import src from "../../../../../images/noImage/noImageInfoBox.png";

const useStyles = makeStyles(theme => ({
  root: {
    width: 240,
    maxHeight: 160,
    "& img":{
      maxWidth: 240,
      maxHeight: 160,
      "margin-left": "auto",
      "margin-right": "auto",
      display: "block"
    }
  }
}));

const FacilityImage = ({ fileId }) => {
  const classes = useStyles();
  const baseURL = "/work/api/file";

  return(<div className={classes.root}>
    {fileId ?
    <img src={`${baseURL}/${fileId}`} />
    : <img src={src} alt="Нет изображения"></img>
    }
  </div>
);
};

export default FacilityImage;
